import GatewayService from '@/service/gateway-service';
import {
  GoalsPositionEnum,
  PositionEnum
} from '@/constants/retail-products-position';
import { PRODUCT } from '../views/product/gql';

/**
 * Product object.
 * @typedef {Object} Product
 * @property {string} id - The ID of the product.
 * @property {string} title - The title of the product.
 * @property {string} handle - The handle of the product.
 * @property {Object} featuredImage - The featured image of the product.
 * @property {string} featuredImage.url - The URL of the featured image of the product.
 */

export default class ProductsService {
  /**
   * @return {Promise<Array<Product>>}
   */
  static async getProducts(query) {
    const response = await GatewayService?.getStoreFront()?.getRequest({
      query
    });

    const getHairType = (handle) => {
      const hairType = ['wavy', 'straight', 'curly', 'coily'].find((type) =>
        handle.includes(type)
      );

      return hairType;
    };

    const products =
      response?.collection?.products?.edges?.map((x) => ({
        ...x.node,
        position: PositionEnum[x.node.handle] ?? { desktop: 100, mobile: 100 },
        hairType: getHairType(x.node.handle),
        goalPosition: GoalsPositionEnum?.[x.node.handle] ?? 100
      })) ?? [];

    return products;
  }

  /**
   * Fetches a product from the Shopify Storefront API.
   *
   * @param {string} productId - The ID of the product (Shopify GID format).
   * @returns {Promise<Product>} - A promise that resolves to the product object.
   */
  static async getProduct(productId) {
    const result = await GatewayService.getStoreFront().getRequest({
      query: PRODUCT,
      variables: { id: productId }
    });

    return result.product;
  }
}
